

import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover';
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService';
import { InsurancePurchaseContextStore, INSURANCE_CONTEXT_ACTIONS } from '../../../context/InsuracePurchaseContext'
import { PolicyHullExtensionContextStore, ACTIONS } from '../../../context/PolicyHullExtensionContext';
import { useLocation, useParams } from 'react-router-dom';
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel';
var classNames = require('classnames')

export const AdditionalCoveragesPopover = (props) => {
  const location = useLocation()
  const insurancePurchaseContext = useContext(InsurancePurchaseContextStore)
  
  const strings: [] = FirebaseService.getArray(FirebaseConfigKey.ADDITIONAL_COVERAGE_TOOLTIP)

  return (
      <SkyInformationPopover eventId={'additional-coverages'}>
          <div className="text-small">- {strings[0]}</div>
          {strings.splice(1).map((text, index) => <div key={index} id={index} className="text-small margin-top-small">- {text}</div>)}
      </SkyInformationPopover>
  );
}